import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { WebServicesService } from "../../services/web-services.service";
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Texto_sitio } from 'src/assets/text_site';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [  
    CommonModule,   
    RouterModule,
    TranslateModule
  ],
  providers:[
    Texto_sitio
  ]
})
export class FooterComponent implements OnInit {
  redes = environment.redes
  checkComplLogin: boolean = false;
  lang: string = 'es';
  todoElIdioma: any;
  constructor(private router: Router, public ws: WebServicesService, private translateService: TranslateService, private activatedRoute: ActivatedRoute, private texto_sitio: Texto_sitio) {
    this.ws.newComplemt = this.activatedRoute.snapshot.params.complement ? this.activatedRoute.snapshot.params.complement : "pasajes";
    this.checkComplementForLogin();
    this.lang = this.translateService.currentLang;
  }

  ngOnInit(): void {
    // if (this.lang == "es") {
    //   this.todoElIdioma = this.texto_sitio.spain;
    // } else {
    //   this.todoElIdioma = this.texto_sitio.english;
    // }
  }

  goUp() {
    window.scrollTo(0, 0);
  }


  pageGo(type) {

    if (type == 1) {
      this.router.navigateByUrl("es/terminos-y-condiciones")
    }

    if (type == 2) {
      this.router.navigateByUrl("es/politicas-cookies")
    }

    if (type == 3) {
      this.router.navigateByUrl("es/politicas-privacidad")
    }
  }

  /**
  * Checkea los complementos para poder mostrar el boton de ingresar al login
  */
  checkComplementForLogin() {
    this.checkComplLogin = this.ws.newComplemt == 'pasajes' || this.ws.newComplemt == 'transfer' || this.ws.newComplemt == 'movired' ? true : false;
  }

}
